import React from '/web_modules/react.js';
import ReactDOM from '/web_modules/react-dom.js';
import App from './App.js';
import './index.css';
ReactDOM.render( /*#__PURE__*/React.createElement(React.StrictMode, null, /*#__PURE__*/React.createElement(App, null)), document.getElementById('root'));
